import React, { useState } from "react";
import { Box, Grid, Card, Typography, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Navigation from "../../../navigations/Navigation";
import BannerImage from "../../../assets/images/Frame.png";
import ReferralIcon from "../../../assets/icons/ReferralLogo.png";
import TrackIcon from "../../../assets/icons/TraclLogoDark.png";
import EarningIcon from "../../../assets/icons/EarningLogo.png";
import ProfileIcon from "../../../assets/icons/ProfileLogo.png";
import ReferralScreen from "./Referral/ReferralScreen";
import ReferralSubmissionScreen from "./Referral/ReferralSubmisionScreen";
import Routes from "../../../utils/Routes";

const Container = styled(Box)({
  textAlign: "center",
  padding: "20px",
});

const Banner = styled("img")({
  width: "100%",
  height: "auto",
  borderRadius: "10px",
  maxWidth: "1634px",
  objectFit: "cover",

  "@media (max-width: 1200px)": {
    maxWidth: "90%",
  },
  "@media (max-width: 768px)": {
    maxWidth: "100%",
  },
});

const MenuCard = styled(Card)({
  padding: "20px",
  textAlign: "center",
  background: "#E5EEE7",
  cursor: "pointer",
  transition: "0.3s",
  "&:hover": {
    transform: "scale(1.05)",
  },
  width: "250px",
  height: "200px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",

  "& img": {
    width: "110px",
    height: "110px",
    objectFit: "contain",
  },

  "& .menuText": {
    marginTop: "12px",
    fontSize: "18px",
    textAlign: "center",
  },

  "@media (max-width: 1024px)": {
    width: "200px",
    height: "180px",
    "& img": {
      width: "90px",
      height: "90px",
    },
    "& .menuText": {
      fontSize: "16px",
    },
  },
  "@media (max-width: 768px)": {
    width: "150px",
    height: "140px",
    padding: "15px",
    "& img": {
      width: "70px",
      height: "70px",
    },
    "& .menuText": {
      fontSize: "14px",
    },
  },
  "@media (max-width: 480px)": {
    width: "110px",
    height: "120px",
    padding: "10px",
    "& img": {
      width: "60px",
      height: "60px",
    },
    "& .menuText": {
      fontSize: "12px",
    },
  },
});

const HomeScreen = ({ className }) => {
  const navigate = useNavigate();
  const [showReferralForm, setShowReferralForm] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleReferralForm = () => {
    setSubmitted(true);
  };

  const handleMenuClick = (route) => {
    if (location.pathname === "/" + route) {
      window.location.reload();
    } else {
      navigate("/" + route);
    }
  };

  return (
    <div className={className}>
      <Navigation />
      <Box className="scrollableContent">
        <Container>
          {showReferralForm ? (
            submitted ? (
              <ReferralSubmissionScreen />
            ) : (
              <ReferralScreen handleReferralForm={handleReferralForm} />
            )
          ) : (
            <>
              {/* Banner Section */}
              <Box mb={3}>
                <Banner
                  src={BannerImage}
                  alt="Referral Program"
                  className="banner"
                />
              </Box>

              <Grid container spacing={3} justifyContent="center">
                <Grid item>
                  <MenuCard onClick={() => setShowReferralForm(true)}>
                    <img
                      src={ReferralIcon}
                      alt="Referral"
                      className="referral"
                    />
                    <Typography className="menuText">Referral</Typography>
                  </MenuCard>
                </Grid>
                <Grid item>
                  <MenuCard onClick={() => handleMenuClick(Routes.Track)}>
                    <img src={TrackIcon} alt="Track" className="track" />
                    <Typography className="menuText">Track</Typography>
                  </MenuCard>
                </Grid>
                <Grid item>
                  <MenuCard onClick={() => handleMenuClick(Routes.Earning)}>
                    <img
                      src={EarningIcon}
                      alt="Earnings"
                      className="earnings"
                    />
                    <Typography className="menuText">Earnings</Typography>
                  </MenuCard>
                </Grid>
                <Grid item>
                  <MenuCard onClick={() => handleMenuClick(Routes.Profile)}>
                    <img src={ProfileIcon} alt="Profile" className="profile" />
                    <Typography className="menuText">Profile</Typography>
                  </MenuCard>
                </Grid>
              </Grid>
            </>
          )}
        </Container>
      </Box>
    </div>
  );
};

export default styled(HomeScreen)(({}) => ({
  ".banner": {
    maxWidth: "100%",
    height: "auto",
    borderRadius: 20,
  },
  ".scrollableContent": {
    position: "absolute",
    top: "64px",
    bottom: "56px",
    left: 0,
    right: 0,
    overflowY: "auto",
    padding: "20px",
  },
  ".menuText": {
    textAlign: "center",
    display: "block",
    marginTop: "12px",
  },
}));
